import { ReactNode } from 'react';
import { SF_UI } from './ui/tokens';

type SectionProps = {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  /** Uppercase micro-label above section title */
  eyebrow?: string;
  centered?: boolean;
  bgColor?: string;
  className?: string;
  id?: string;
};

/**
 * Page section shell aligned with One World content bands and title hierarchy.
 */
const Section = ({
  children,
  title,
  subtitle,
  eyebrow,
  centered = false,
  bgColor = 'bg-white',
  className = '',
  id,
}: SectionProps) => {
  return (
    <section
      id={id}
      className={`${SF_UI.systemId} py-16 ${bgColor} ${className}`}
      data-sf-ui="section"
    >
      <div className="container mx-auto px-4">
        {(title || subtitle || eyebrow) && (
          <div className={`mb-12 ${centered ? 'text-center' : ''}`}>
            {eyebrow && (
              <p className={`mb-2 ${SF_UI.microLabelOnLight}`}>{eyebrow}</p>
            )}
            {title && (
              <h2 className="mb-4 text-3xl font-bold tracking-tight text-gray-900 md:text-4xl">
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="max-w-3xl text-lg text-gray-600 md:text-xl mx-auto">
                {subtitle}
              </p>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
};

export default Section;
